import { MutationTree } from 'app/node_modules/vuex'
import { ConversationType, MessageStateInterface } from 'src/store/message/state'
import { Message, Group } from 'able-lib'
import { deleteProp, setProp } from 'src/lib/helper'
import { Room } from 'components/ChatWindow/model'

const mutation: MutationTree<MessageStateInterface> = {
  SET_ANNOUNCEMENTS (state: MessageStateInterface, announcements: Array<Message>) {
    state.announcements = announcements
  },

  SET_ANNOUNCEMENT (state: MessageStateInterface, announcement: Message) {
    state.announcement = announcement
  },

  SET_ANNOUNCEMENT_PROP (state, { path, value }: { path: Array<string>; value: any }) {
    console.log('SET_ANNOUNCEMENT_PROP', path)
    setProp(state.announcement, path, value)
  },

  REMOVE_ANNOUNCEMENT_PROP (state, path: Array<string>) {
    deleteProp(state.announcement, path)
  },

  SET_UNREAD_ANNOUNCEMENT_COUNT (state, count: number) {
    state.unreadAnnouncementCount = count
  },

  SET_POLICIES (state: MessageStateInterface, policies: Array<Message>) {
    state.policies = policies
  },

  UPDATE_ANNOUNCEMENT (state: MessageStateInterface, updatedAnnouncement: Message) {
    const foundAnnouncementIndex = state.announcements.findIndex(announcement => announcement.id === updatedAnnouncement.id)
    state.announcements[foundAnnouncementIndex] = updatedAnnouncement
    state.announcement = updatedAnnouncement
  },

  // ==========================================
  // Messaging
  // ==========================================

  UPDATE_CONVERSATION_TYPE (state: MessageStateInterface, type: ConversationType) {
    state.conversationType = type
  },

  SET_CONVERSATIONS (state: MessageStateInterface, conversations: Array<Room>) {
    state.conversations = conversations
  },

  SET_CONVERSATIONS_PROP (state: MessageStateInterface, { path, value }: { path: Array<string>; value: any }) {
    setProp(state.conversations, path, value)
  },

  SET_MESSAGES (state: MessageStateInterface, messages: Array<any>) {
    state.messages = messages
  },

  SET_CONVERSATIONS_UNREAD_MESSAGES (state: MessageStateInterface, unreadMessages: Array<any>) {
    state.conversationsUnreadMessages = unreadMessages
  },

  SET_CONVERSATIONS_UNREAD_MESSAGES_PROP (state: MessageStateInterface, { path, value }: { path: Array<string>; value: any }) {
    setProp(state.conversationsUnreadMessages, path, value)
  },

  SET_CONVERSATION (state: MessageStateInterface, conversation: any) {
    state.conversation = conversation
  },

  SET_CHAT_MESSAGE_DRAFT (state: MessageStateInterface, messageDraft: Group) {
    state.chatMessageDraft = messageDraft
  },

  SET_CHAT_MESSAGE_PROP (state, { path, value }: { path: Array<string>; value: any }) {
    setProp(state.chatMessageDraft, path, value)
  },

  SET_CONTACTS (state: MessageStateInterface, contacts) {
    state.contacts = contacts.user
  }
}

export default mutation
